








import { defineComponent, PropType } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import { bemx } from '@berlin-front/common/utils';
import { TEXT_SIZE, LINE_HEIGHT, TextSize, LineHeight } from '../AppText/composable';

/**
 * ## メッセージリスト
 *
 * アラートメッセージのリスト表示で利用する。
 * メッセージの配列を受け取り、リストタグ出力するだけのコンポーネント。
 *
 */
export default defineComponent({
  name: 'AppMessageList',
  components: {
    AppText,
  },

  props: {
    lineHeight: {
      type: String as PropType<LineHeight>,
      required: false,
      default: LINE_HEIGHT.HEIGHT150,
    },

    messages: {
      type: Array as PropType<string[]>,
      required: true,
    },

    textSize: {
      type: String as PropType<TextSize>,
      required: false,
      default: TEXT_SIZE.CAPTION,
    },
  },

  setup() {
    const className = bemx('AppMessageList');

    return {
      className,
      text: {
        height: {
          height150: LINE_HEIGHT.HEIGHT150,
        },

        size: {
          caption: TEXT_SIZE.CAPTION,
        },
      },
    };
  },
});
